import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import "remixicon/fonts/remixicon.css"
import "@/shared/fonts"
import "./i18n"
import "./index.css"
import App from "@/app/App"

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
